var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceidNGeolocBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(29.64 0 0 33.3 815.96 362.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(65,101,246)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(65,101,246)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12, -12)",
    d: "M 11.291 21.706 L 12 21 L 11.291 21.706 z M 12 21 L 12.708 21.706 C 12.520351504435844 21.894390140649268 12.265399986802072 22.000289188123066 11.999500000000001 22.000289188123066 C 11.733600013197929 22.000289188123066 11.478648495564157 21.894390140649268 11.291 21.706 L 11.285 21.698999999999998 L 11.268 21.682 L 11.206000000000001 21.619 C 10.853489032142633 21.255872848734988 10.506778478598338 20.887159510061924 10.165999999999995 20.512999999999998 C 9.310399203148695 19.575472675449582 8.49112850402481 18.605424144076515 7.710000000000004 17.605000000000004 C 6.8180000000000005 16.455 5.906000000000001 15.154999999999998 5.213000000000001 13.870999999999997 C 4.535 12.612 4 11.248 4 10 C 4 5.461 7.5920000000000005 2 12 2 C 16.408 2 20 5.461 20 10 C 20 11.248 19.465 12.612 18.787 13.870000000000001 C 18.093999999999998 15.156 17.183 16.455000000000002 16.29 17.605 C 15.197379676241523 19.00463219438944 14.030365093825433 20.344562553033086 12.794000000000004 21.61899999999999 L 12.732 21.682 L 12.715 21.698999999999998 L 12.709 21.705 L 12 21 z M 12 13 C 13.65685424949238 13 15 11.65685424949238 15 10 C 15 8.34314575050762 13.65685424949238 7 12 7 C 10.34314575050762 7 9 8.34314575050762 9 10 C 9 11.65685424949238 10.34314575050762 13 12 13 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.66 0 0 41.66 151.68 362.59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(65,101,246)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-5, -5)",
    d: "M 7 3 L 5 3 C 3.89543 3 3 3.89543 3 5 L 3 7",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.66 0 0 41.66 608.1 576.73)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(65,101,246)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "rgb(65,101,246)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-16, -9)",
    d: "M 16 8 L 16 10",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.66 0 0 41.66 280.31 578.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(65,101,246)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-8, -9)",
    d: "M 8 8 L 8 10",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.66 0 0 41.66 443.3 841.67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(65,101,246)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12, -16.5)",
    d: "M 9 16 C 9 16 10 17 12 17 C 14 17 15 16 15 16",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.66 0 0 41.66 424.29 641.04)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(65,101,246)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-11.5, -10.5)",
    d: "M 12 8 L 12 13 L 11 13",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.66 0 0 41.66 151.68 945.82)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(65,101,246)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-5, -19)",
    d: "M 7 21 L 5 21 C 3.89543 21 3 20.1046 3 19 L 3 17",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(41.66 0 0 41.66 734.9 945.82)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(65,101,246)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-19, -19)",
    d: "M 17 21 L 19 21 C 20.1046 21 21 20.1046 21 19 L 21 17",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceidNGeolocBlue);
export default __webpack_public_path__ + "static/media/faceid-n-geoloc-blue.649079c460099f73bc02b107bc29f939.svg";
export { ForwardRef as ReactComponent };